<div class="item" *ngIf="!loading" [@fadeIn]>
  <div class="item__top">{{label}}</div>
  <div class="item__bottom" [class.item__bottom--primary]="primary"><ng-content></ng-content></div>
</div>
<div class="ph-item" *ngIf="loading">
  <div class="ph-row">
    <div class="ph-col-12 big"></div>
  </div>
</div>
